<template>

  <v-row justify="center">
    <v-col cols="10">

    <v-row justify="center" v-if="loading">
      <v-progress-circular :size="40" :width="7" color="secondary" indeterminate></v-progress-circular>
    </v-row>
</v-col>
    <v-snackbar v-model="message.visible" :color="message.type" :timeout="message.duration" top>
      {{message.body}}
      <v-btn dark text @click="message.visible = false">Close</v-btn>
    </v-snackbar>

    <v-col cols="10">
      <v-simple-table v-if="imports.length">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Source</th>
              <th class="text-left">Status</th>
              <th class="text-left">Submitted date</th>
              <th class="text-left">Finished date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in imports" :key="item.task_id">
              <td>{{ item.source }}</td>
              <td>
                <v-icon :color="iconsColor[item.status] || 'secondary'">{{icons[item.status]}}</v-icon>
                {{ item.status }}
              </td>
              <td>{{item.created.toLocaleString()}}</td>
              <td
                :class="[{'caption': !item.ended}]"
              >{{item.ended?item.ended.toLocaleString():'Not available yet'}}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div v-else class="mx-auto text-center">
        <p>There is no imports</p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import MessagingMixin from "../../../mixins/messaging";
import { SUCCESS, FAILURE, PROCESSING } from "../store/types";

export default {
  mixins: [MessagingMixin],

  data() {
    return {
      icons: {
        [SUCCESS]: "mdi-check",
        [FAILURE]: "mdi-close-circle",
        [PROCESSING]: "mdi-clock-outline"
      },
      iconsColor: {
        [FAILURE]: "#f40303"
      } 
    };
  },
  mounted(){
    this.$store.dispatch("imports/getUserImports");
  },
  computed: {
    imports() {
      return this.$store.getters["imports/allImports"];
    },
        loading() {
      return this.$store.getters["imports/loading"];
    }
  }
};
</script>

<style scoped>
</style>